import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
import Barcode from 'react-barcode';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import $ from 'jquery';
import BarcodePage from "./barcode";
import { TbPasswordFingerprint } from 'react-icons/tb';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("TaggedScreen_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    setTagId("{Auto}");
    setTagNo("{Auto}");

	//Clear();
   
   }
   else if(sessionStorage.getItem("TaggedScreen_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("TaggedScreen_EditId"));
   }
   else if(sessionStorage.getItem("TaggedScreen_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("TaggedScreen_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  GetGrnDetails1();
  }

  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtSmith, setdtSmith]=useState([]);
  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtGrnDetails, setdtGrnDetails]=useState([]);
  const [dtGrnDetailsOrg, setdtGrnDetailsOrg]=useState([]);
  const [dtSize, setdtSize]=useState([]);
  const [dtTagType, setdtTagType]=useState([]);
  const [dtStone, setdtStone]=useState([]);
  const [dtStProd, setdtStProd]=useState([]);
  const [dtStSubProd, setdtStSubProd]=useState([]);

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  
   const [TMshow2, setTMShow2] = useState(false);
   const TMhandleClose2 = () => setTMShow2(false);
  
   const [Tagshow2, setTagShow2] = useState(false);
   const TaghandleClose2 = () => setTagShow2(false);
  


   const [LotNo, setLotNo, LotNoRef] = useStateRef(0);
   
   const [IssueNo, setIssueNo, IssueNoRef] = useStateRef(0);
   const [LotDate, setLotDate, LotDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   
   const [ProdName1, setProdName1, ProdName1Ref] = useStateRef('');
   const [GrossWt1, setGrossWt1, GrossWt1Ref] = useStateRef(0);
   const [GrossWtC1, setGrossWtC1, GrossWtC1Ref] = useStateRef(0);
   const [GrossWtP1, setGrossWtP1, GrossWtP1Ref] = useStateRef(0);
   const [Pcs1, setPcs1, Pcs1Ref] = useStateRef(0);
   const [PcsC1, setPcsC1, PcsC1Ref] = useStateRef(0);
   const [PcsP1, setPcsP1, PcsP1Ref] = useStateRef(0);
 

   const [TagId, setTagId, TagIdRef] = useStateRef(0);
   const [TagNo, setTagNo, TagNoRef] = useStateRef('');
   const [HUIDNo, setHUIDNo, HUIDNoRef] = useStateRef('');
   const [ProdCode, setProdCode, ProdCodeRef] = useStateRef(0);
   const [SubCode, setSubCode, SubCodeRef] = useStateRef(0);
   const [TagTypeId, setTagTypeId, TagTypeIdRef] = useStateRef(0);
   const [SizeCode, setSizeCode, SizeCodeRef] = useStateRef(0);
   const [Pcs, setPcs, PcsRef] = useStateRef(0);
   const [GrossWt, setGrossWt, GrossWtRef] = useStateRef(0);
   const [Touch, setTouch, TouchRef] = useStateRef(0);
   const [NetWt, setNetWt, NetWtRef] = useStateRef(0);
   const [Rate, setRate, RateRef] = useStateRef(0);
   const [LessWt, setLessWt, LessWtRef] = useStateRef(0);
   const [WasteP, setWasteP, WastePRef] = useStateRef(0);
   const [Waste, setWaste, WasteRef] = useStateRef(0);
   const [MCP, setMCP, MCPRef] = useStateRef(0);
   const [MC, setMC, MCRef] = useStateRef(0);
   const [HMCharges, setHMCharges, HMChargesRef] = useStateRef(0);
   const [OtherCharges, setOtherCharges, OtherChargesRef] = useStateRef(0);
   const [OrderNo, setOrderNo, OrderNoRef] = useStateRef(0);
   const [StoneAmt, setStoneAmt, StoneAmtRef] = useStateRef(0);
   const [StoneWtMode, setStoneWtMode, StoneWtModeRef] = useStateRef(0);
   const [id, setid, idRef] = useStateRef(0);
   const [MCGrm, setMCGrm, MCGrmRef] = useStateRef(0);
   
   const [LabelTxt, setLabelTxt, LabelTxtRef] = useStateRef('GRN No');
   const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');

   const [StProdCode, setStProdCode, StProdCodeRef] = useStateRef(0);
   const [StSubCode, setStSubCode, StSubCodeRef] = useStateRef(0);
   const [StonePcs, setStonePcs, StonePcsRef] = useStateRef(0);
   const [StoneWt, setStoneWt, StoneWtRef] = useStateRef(0);
   const [StoneRate, setStoneRate, StoneRateRef] = useStateRef(0);
   const [StoneAmount, setStoneAmount, StoneAmountRef] = useStateRef(0);
   const [GoldRate, setGoldRate, GoldRateRef] = useStateRef(0);
   const [SilverRate, setSilverRate, SilverRateRef] = useStateRef(0);
   const [MetalCode, setMetalCode, MetalCodeRef] = useStateRef(0);
   const [WMode, setWMode, WModeRef] = useStateRef(0);
   const [PcsRate, setPcsRate, PcsRateRef] = useStateRef(0);
   const [ItemRate, setItemRate, ItemRateRef] = useStateRef(0);
   
   const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
   let StDetTable=[];
 

   async function StgridEdit (id) {

    StDetTable=DtStDetTable;

    var cnt = 0;
    try {
        cnt = StDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }


    let i=0;

    for (i = 0; i < cnt; i++) {
        if (StDetTable[i].ID == id) {

            setid(id);
            setStProdCode(StDetTable[i].StProdName);
            setStSubCode(StDetTable[i].StSubProdName);
            setStonePcs(StDetTable[i].StPcs);
            setStoneWt(StDetTable[i].StWt);
            setStoneRate(StDetTable[i].StRate);
            setStoneAmount(StDetTable[i].StAmount);
            

     await getStsubProd();
     setStSubCode(StDetTable[i].StSubProdName);

            break;

        }          
    }

    setDtStDetTable(StDetTable);
  


}



async function StAmountCalc()
{

  StDetTable=DtStDetTableRef.current;


    var cnt = 0;
    try
    {
        cnt = StDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }

    let stamt=0;
    let i=0;

    for (i = 0; i < cnt; i++) {
    stamt=val(stamt) + val(StDetTable[i].StAmount);

    }

    setStoneAmt(stamt);


}
   
 async function stgridAdd () {



  let slno=idRef.current;

if ((StProdCodeRef.current.length>0)&&(StSubCodeRef.current.length>0)&&(val(StonePcsRef.current)>0) && (val(StoneRateRef.current)>0))

{
  StDetTable=DtStDetTableRef.current;


    var cnt = 0;
    try
    {
        cnt = StDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }


  
    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {

        if (StDetTable[i].ID == slno) {


          StDetTable[i].StProdName=StProdCodeRef.current;
          StDetTable[i].StSubProdName=StSubCodeRef.current;
          StDetTable[i].StPcs=StonePcsRef.current;
          StDetTable[i].StWt=StoneWtRef.current;
          StDetTable[i].StRate=StoneRateRef.current;
          StDetTable[i].StAmount=StoneAmountRef.current;
       
           
         
            //det text box clear

          StClear();

            found = true;
            break;
        }
        else {


            if ((StDetTable[i].StProdName == StProdCodeRef.current) && (StDetTable[i].StSubProdName == StSubCodeRef.current) && (parseFloat(StDetTable[i].StPcs).toFixed(3) == parseFloat(StonePcsRef.current).toFixed(3))) {
                swal({
        title: "",
        text: "Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

        var row = {
            "ID": parseInt(cnt) + 1
            , "StProdName":StProdCodeRef.current
            , "StSubProdName":StSubCodeRef.current
            , "StPcs":StonePcsRef.current
            , "StWt":StoneWtRef.current
            , "StRate":StoneRateRef.current
            , "StAmount":StoneAmountRef.current
            
        };
        
        
        StDetTable[cnt] = row;

         StClear();
        

         //Calc();

           

    }
  
  await setDtStDetTable(StDetTable);



  //alert(JSON.stringify(DtDetTable));

  await StAmountCalc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}

function StClear()
{
setStProdCode("");
setStSubCode("");
setStonePcs("");
setStoneWt("");
setStoneRate("");
setStoneAmount("");
setid("");

}

function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.IssueNo.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  

 
  async function Clear()
   {
    
    setProdCode(0);
    setSubCode(0);
    setPcs(0);
    setGrossWt(0);
		setLessWt(0);
    setNetWt(0);
    setWasteP(0);
    setWaste(0);
    setMCP(0);
    setMC(0);
    setTagTypeId(0);
    setSizeCode(0);
    setTouch(TouchRef.current);
    setRate(0);
    setTagId("{Auto}");
    setTagNo("{Auto}");
    setHUIDNo("");
    setHMCharges("")
    setOtherCharges("");
    setOrderNo("");
    setStoneAmt("");
    setDtStDetTable([]);

		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}


async function Calc1()
{
  setWaste((val(NetWtRef.current)*val(WastePRef.current)/100).toFixed(2));
  
  if(SubCodeRef.current==160)
  {
    setMC(val(MCGrmRef.current)*val(NetWtRef.current));

    if(MCPRef.current>0)
    {
      setMCGrm(((val(MCPRef.current)*val(GoldRateRef.current))/100).toFixed(2));
      setMC(val(MCGrmRef.current)*val(NetWtRef.current));
    }
    else
    {
      setMCGrm(0);
    }

    if(MetalCodeRef.current=="G")
    {
      setMCP(0);
      setMCGrm(0);
      setMC(0);
      
    }
  }
}

async function Calc()
{
  
  setNetWt(val(GrossWtRef.current)-val(LessWtRef.current));

  if(val(NetWtRef.current)>val(GrossWtP1Ref.current))
  {
    let DiffWt=val(NetWtRef.current)-val(GrossWtP1Ref.current);
    swal({
      title: "",
      text: "The Weight Difference : " + DiffWt,
      icon: "info",
      button: "Ok"
    
    });
    
    setGrossWt(0);
    setLessWt(0);
    setNetWt(0);
    
    return;
  }



  if(val(PcsRef.current)>val(PcsP1Ref.current))
    {
      let DiffWt=val(PcsRef.current)-val(PcsP1Ref.current);
      swal({
        title: "",
        text: "The Pcs Difference : " + DiffWt,
        icon: "info",
        button: "Ok"
      
      });
      
      setPcs(0);

      return;
    }



  let postData = {
    "GrnNo":LotNoRef.current,
    "NetWt":NetWtRef.current,
    "ProdCode": ProdCodeRef.current,
    "SubCode": SubCodeRef.current,
    "InfoCode":TagTypeIdRef.current,
    "LotDate":LotDateRef.current,
    "Touch":TouchRef.current,
    "Pcs":PcsRef.current,
    "GrossWt":GrossWtRef.current
}


const results = await apiService.postCall("taggedscreen/getcalc",postData);

if (results != "-1") {
  setWasteP(results.data[1]);
  setMCP(results.data[2]);
  setMCGrm(results.data[3]);
  setGoldRate(results.data[8]);
  setSilverRate(results.data[9]);
  setMetalCode(results.data[10]);
  setWMode(results.data[0]);
  setPcsRate(results.data[11]);
  setItemRate(results.data[12]);



  setWaste((val(NetWtRef.current)*val(WastePRef.current)/100).toFixed(2));
  
  if(SubCodeRef.current==160)
  {
    setMC(val(MCGrmRef.current)*val(NetWtRef.current));

    if(MCPRef.current>0)
    {
      setMCGrm(((val(MCPRef.current)*val(GoldRateRef.current))/100).toFixed(2));
      setMC(val(MCGrmRef.current)*val(NetWtRef.current));
    }
    else
    {
      setMCGrm(0);
    }

    if(MetalCodeRef.current=="G")
    {
      setMCP(0);
      setMCGrm(0);
      setMC(0);
      
    }
  }

}



}

function StoneCalc()
{
  if(StoneWtModeRef.current=="P")
  {
    setStoneAmount((val(StonePcsRef.current)*val(StoneRateRef.current)).toFixed(2));
  }
  else  if(StoneWtModeRef.current=="W")
  {
    setStoneAmount((val(StoneWtRef.current)*val(StoneRateRef.current)).toFixed(2));
  }
  else  if(StoneWtModeRef.current=="C")
  {
    setStoneAmount((val(StoneWtRef.current)*val(StoneRateRef.current)).toFixed(2));
  }
  else
  {
    setStoneAmount((val(StonePcsRef.current)*val(StoneRateRef.current)).toFixed(2));
  }
}
async function ControlSettings()
{

  document.getElementById("txtLotNo").disabled ='true';
  
  
  if((sessionStorage.getItem("TaggedScreen_Action")=="Edit") || (sessionStorage.getItem("TaggedScreen_Action")=="Delete"))
   {
  
   
   }
}



async function GetGrnDetails1()
{
  try
  {
   
    let postData = {
      "BranchCode":sessionStorage.getItem("BranchCode")
  }

  const results = await apiService.postCall("taggedscreen/GetGrnDetails1",postData);

 if (results != "-1") {
   setdtGrnDetails(results.data[0]);
   setdtGrnDetailsOrg(results.data[0]);
 }

  
  }
  catch (error) {
    console.log(error);
  }
}

async function TagPrint()
{
  try
  {
   
    let postData = {
      TagId: TagIdRef.current
  }

  

  const results = await apiService.postCall("taggedscreen/tagprint",postData);


 if (results != "-1") {

 }
}

catch (error) {
  console.log(error);
}
}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    const results = await apiService.postCall("taggedscreen/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let StoneData=results.data.Stone;
 

  
   getLookup();
   
   setIssueNo(HeadData[0][0].IssueNo);
   setLotNo(HeadData[0][0].GrnNo);
   setLotDate(HeadData[0][0].TagedDate.substring(0,10));
   setTagId(HeadData[0][0].TagId);
   setTagNo(HeadData[0][0].TagNo);
   
   setProdCode(HeadData[0][0].ProdCode);
   setSubCode(HeadData[0][0].SubCode);
   setTagTypeId(HeadData[0][0].infoCode);
   setSizeCode(HeadData[0][0].SizeCode);
   setHUIDNo(HeadData[0][0].HUID_No);
   setPcs(HeadData[0][0].Pcs);
   setGrossWt(HeadData[0][0].GrossWt.toFixed(2));
   setRate(HeadData[0][0].Rate);
   setLessWt(HeadData[0][0].LessWt.toFixed(2));
   setNetWt(HeadData[0][0].NetWt.toFixed(2));
   setTouch(HeadData[0][0].Touch);
   setWasteP(HeadData[0][0].WastePer);
   setWaste(HeadData[0][0].Wastage);
   setMCP(HeadData[0][0].McPer);
   setMC(HeadData[0][0].Mc);
   setMCGrm(HeadData[0][0].McGram);
   setHMCharges(HeadData[0][0].HalMarkCharges);
   setOtherCharges(HeadData[0][0].OtherCharges);
   setOrderNo(HeadData[0][0].OrderNo);
   setStoneAmt(HeadData[0][0].StoneAmt);
   setMetalCode(HeadData[0][0].MetalType);
   setWMode(HeadData[0][0].salemode);
   setPcsRate(HeadData[0][0].PcsRate);
   setItemRate(HeadData[0][0].ItemRate);
   setGoldRate(HeadData[0][0].GoldRate);
   setSilverRate(HeadData[0][0].SilverRate);


   setDtStDetTable([]);

   StDetTable=DtStDetTableRef.current;


    var cnt = 0;
    
    var i=0;



    for(i=0;i<=StoneData[0].length-1;i++)
      {

        
    var row = {
      "ID": parseInt(cnt) + 1
      , "StProdName":StoneData[0][i].StProdName
      , "StSubProdName":StoneData[0][i].StSubProdName
      , "StPcs":StoneData[0][i].StonePcs
      , "StWt":StoneData[0][i].StoneWt
      , "StRate":StoneData[0][i].StoneRate
      , "StAmount":StoneData[0][i].StoneAmount
      
    };

  

  StDetTable[cnt] = row;
  cnt=cnt+1;

    }

   await setDtStDetTable(StDetTable);
    
   
   await setCheck(IssueNoRef.current,LotNoRef.current);

   await Calc();

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function Err(msg)
  {
 
        swal({

          title: "",
          text: msg,
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
  }


async function Save(){
	  try
		{
	
		// validation start
		
  
    if(LotNoRef.current=="0")
    {
      await Err("Please Select Lot No");
      return;
    }

    if(ProdCodeRef.current=="0")
    {
      await Err("Please Select Product");
      return;
    }

    if(SubCodeRef.current=="0")
    {
      await Err("Please Select Sub Product");
      return;
    }

    if(val(PcsRef.current)=="0")
    {
      await Err("Enter Pcs");
      return;
    }

    if(WModeRef.current!="PCS RATE")
      {
    if(val(GrossWtRef.current)=="0")
    {
      await Err("Enter GrossWt");
      return;
    }
  }

    if(val(TouchRef.current)=="0")
    {
      await Err("Enter Touch");
      return;
    }
      

      // validation end


      if(MetalCodeRef.current=="G")
        setRate(GoldRateRef.current);
      else if(MetalCodeRef.current=="S")
        setRate(SilverRateRef.current);
      else
        setRate(GoldRateRef.current);
      

		 
		let postData = {
			"Action" : sessionStorage.getItem("TaggedScreen_Action"),
			"EditId" : sessionStorage.getItem("TaggedScreen_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
		  "BIssueNo":IssueNoRef.current,
      "LotNo":LotNoRef.current,
      "LotDate":LotDateRef.current,
      "ProdCode":ProdCodeRef.current,
      "SubCode":SubCodeRef.current,
      "InfoCode":TagTypeIdRef.current,
      "SizeCode":SizeCodeRef.current,
      "HUIDNo":HUIDNoRef.current,
      "Pcs":PcsRef.current,
      "GrossWt":GrossWtRef.current,
      "Rate":RateRef.current,
      "LessWt":LessWtRef.current,
      "NetWt": NetWtRef.current,
      "Touch": TouchRef.current,
      "WasteP":WastePRef.current,
      "Waste":WasteRef.current,
      "MCP":MCPRef.current,
      "MC":MCRef.current,
      "MCGrm":MCGrmRef.current,
      "HMCharges":HMChargesRef.current,
      "OtherCharges":OtherChargesRef.current,
      "OrderNo":OrderNoRef.current,
      "StoneAmt":StoneAmtRef.current,
      "GoldRate":GoldRateRef.current,
      "SilverRate":SilverRateRef.current,
      "MetalCode":MetalCodeRef.current,
      "WMode":WModeRef.current,
      "StoneWtMode":StoneWtModeRef.current,
      "PcsRate":PcsRateRef.current,
      "ItemRate":ItemRateRef.current,
      "StoneDetails": DtStDetTableRef.current
    }

    const results = await apiService.postCall("taggedscreen/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{

  
  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    return;
  });

  return;

}  




  if(sessionStorage.getItem("TaggedScreen_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(async function () {
     await setCheck(IssueNoRef.current,LotNoRef.current);
     Clear();
     if(val(PcsP1Ref.current)==0)
     {BackToList();}
      
    });
	
  }

  else if(sessionStorage.getItem("TaggedScreen_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("TaggedScreen_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function setCheck(id,GrnNo)
  {


   

    try
  {
   
   
  
    let postData = {
      "IssueNo": id,
      "Id": TagIdRef.current,
      "GrnNo":GrnNo
  }

  
  const results = await apiService.postCall("taggedscreen/GetGrnDetails",postData);

  


 if (results != "-1") {
  
  let data=results.data[0];
  let StoneData=results.data[3];
  
  

  setLotNo(data[0][0].GrnNo);
  setIssueNo(data[0][0].IssueNo);

  setProdName1(data[0][0].ProdName);
  setGrossWt1(data[0][0].GrossWt.toFixed(2));
  setGrossWtC1(data[0][0].TagedWt.toFixed(2));
  setGrossWtP1(data[0][0].BalWt.toFixed(2));
  setPcs1(data[0][0].Pcs);
  setPcsC1(data[0][0].TagedPcs);
  setPcsP1(data[0][0].BalPcs);
  
  setStoneWtMode(results.data[1]);
  setTouch(results.data[2]);


  setDtStDetTable([]);

   StDetTable=DtStDetTableRef.current;


    var cnt = 0;
    
    var i=0;



    for(i=0;i<=StoneData[0].length-1;i++)
      {

        
    var row = {
      "ID": parseInt(cnt) + 1
      , "StProdName":StoneData[0][i].StProdName
      , "StSubProdName":StoneData[0][i].StSubProdName
      , "StPcs":StoneData[0][i].StonePcs
      , "StWt":StoneData[0][i].StoneWt
      , "StRate":val(StoneData[0][i].StoneRate)*2
      , "StAmount":val(StoneData[0][i].StoneAmount)*2
      
    };

  

  StDetTable[cnt] = row;




 }

 

 setTMShow1(false);

 StAmountCalc();

 }
  
  }
  catch (error) {
    console.log(error);
  }

   


}


async function getStsubProd(){
  try {
 
    let postData = {
    "ProdCode" : StProdCodeRef.current
   };
   

  const results = await apiService.postCall("taggedscreen/getStsubProd",postData);

  if (results != "-1") {
    setdtStSubProd(results.data[0][0]);
   
   }
} catch (error) {
     console.log(error);
   }
}




  async function getsubProd(){
    try {
     
     let postData = {
      "ProdCode" : ProdCodeRef.current
     };
     
  
    const results = await apiService.postCall("taggedscreen/getsubProd",postData);
 
    if (results != "-1") {
      setdtSubProd(results.data[0][0]);
      setdtSize(results.data[1][0]);
     }
} catch (error) {
       console.log(error);
     }
 }

  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : ProdCodeRef.current
    };
		
    const results = await apiService.postCall("taggedscreen/Lookup",postData);

	 if (results != "-1") {

    setdtProd(results.data[0][0]);
    setdtSubProd(results.data[1][0]);
    setdtTagType(results.data[2][0]);
    setdtSize(results.data[3][0]);
    setdtStProd(results.data[4][0]);
    setdtStSubProd(results.data[5][0]);

      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/taggedscreen/list');
  };

  return (
    <>
    

      <Row className="">
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Tagged Entry Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-12' id="div100">
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                        <div className='col-md-2'>
                            <Form.Label><a onClick = {(e) => {
                              if(sessionStorage.getItem("TaggedScreen_Action")=="Add")
                             { setTMShow1(true)}

                              }} href="#">Lot No</a></Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtLotNo" placeholder="" value={LotNo}  />
                          </div>
                         
                          <div className='col-md-3'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" disabled="disabled" id="txtLotDate" placeholder="" value={LotDate} onChange={(e)=>setLotDate(e.target.value)} />
                          </div>

                          <div className='col-md-7'>
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtProdName1" placeholder="" value={ProdName1} onChange={(e)=>setProdName1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWt1" placeholder="" value={GrossWt1} onChange={(e)=>setGrossWt1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtC1" placeholder="" value={GrossWtC1} onChange={(e)=>setGrossWtC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtP1" placeholder="" value={GrossWtP1} onChange={(e)=>setGrossWtP1(e.target.value)} />
                          </div>



                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcs1" placeholder="" value={Pcs1} onChange={(e)=>setPcs1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsC1" placeholder="" value={PcsC1} onChange={(e)=>setPcsC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsP1" placeholder="" value={PcsP1} onChange={(e)=>setPcsP1(e.target.value)} />
                          </div>

    
   </div>
	  </div>
</div>

</div>


                  </div>
                 


                  <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                          <div className='col-md-12'>
                            <Form.Label>Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtProd.filter(function(option) {
                                             return option.value === ProdCode;
                                           })}
                                          options={dtProd}
                                          id="txtProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setProdCode(e.value)
                                              getsubProd()   
                                             }
                                             } >

                            </Select>

                            
                          </div>


                          <div className='col-md-12'>
                            <Form.Label>Sub Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtSubProd.filter(function(option) {
                                             return option.value === SubCode;
                                           })}
                                          options={dtSubProd}
                                          id="txtSubProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSubCode(e.value)
                                             }
                                             } >

                            </Select>



                          </div>


                          <div className='col-md-6'>
                            <Form.Label>Tag Type</Form.Label>

                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtTagType.filter(function(option) {
                                             return option.value === TagTypeId;
                                           })}
                                          options={dtTagType}
                                          id="txtTagType"  
                                          onChange=
                                          {
                                             (e) => {
                                              setTagTypeId(e.value)
                                             }
                                             }>

                            </Select>
                           
                          </div>



                        
                          <div className='col-md-6'>
                            <Form.Label>Size</Form.Label>

                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtSize.filter(function(option) {
                                             return option.value === SizeCode;
                                           })}
                                          options={dtSize}
                                          id="txtSize"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSizeCode(e.value)
                                             }
                                             }>

                            </Select>

                            
                          </div>

   </div>
	  </div>
</div>

</div>


  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>
                        <div className='col-md-4'>
                            <Form.Label>Tag Id</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagId" placeholder="" value={TagId} onChange={(e)=>setTagId(e.target.value)} />
                          </div>
                       
                          <div className='col-md-4'>
                            <Form.Label>Tag No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagNo" placeholder="" value={TagNo} onChange={(e)=>setTagNo(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>HUID No</Form.Label>
                            <Form.Control type="text"  id="txtHUIDNo" placeholder="" value={HUIDNo} onChange={(e)=>setHUIDNo(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtPcs" onBlur={Calc} placeholder="" value={Pcs} onChange={(e)=>setPcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" placeholder="" value={GrossWt} 
                            onChange={(e)=>{setGrossWt(e.target.value)
                            }
                          } onBlur={Calc} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Touch</Form.Label>
                            <Form.Control type="text" id="txtTouch" placeholder="" value={Touch} 
                            onChange={(e)=>{
                              setTouch(e.target.value)
                                  
                            }
                          } onBlur={Calc} />
                          </div>

   
   </div>
	  </div>    
</div>

</div>

                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>
                        <div className='col-md-2'>
                            <Form.Label>Rate</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtItemRate" placeholder="" value={ItemRate} onChange={(e)=> 
                            {
                              setItemRate(e.target.value)
                             
                            }} onBlur={Calc} />
                          </div>
                       
                          <div className='col-md-2'>
                            <Form.Label>Less Wt</Form.Label>
                            <Form.Control type="text"   id="txtLessWt" placeholder="" value={LessWt} onChange={(e)=>{
                              setLessWt(e.target.value)
                              }} onBlur={Calc} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text"  Readonly="Readonly" disabled="disabled" id="txtNetWt" placeholder="" value={NetWt} onChange={(e)=>setNetWt(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Waste %</Form.Label>
                            <Form.Control type="text"  id="txtWasteP" placeholder="" value={WasteP} onChange={
                              (e)=>{setWasteP(e.target.value)
                                Calc1();
                              }
                              } />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Waste</Form.Label>
                            <Form.Control type="text" id="txtWaste" Readonly="Readonly" disabled="disabled" placeholder="" value={Waste} onChange={(e)=>setWaste(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>MC %</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtMCP" placeholder="" value={MCP} onChange={(e)=>setMCP(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>MC</Form.Label>
                            <Form.Control type="text" id="txtMC" placeholder="" value={MC} onChange={(e)=>setMC(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>HM Charges</Form.Label>
                            <Form.Control type="text"  id="txtHMCharges" placeholder="" value={HMCharges} onChange={(e)=>setHMCharges(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Other Charges</Form.Label>
                            <Form.Control type="text"  id="txtOtherCharges" placeholder="" value={OtherCharges} onChange={(e)=>setOtherCharges(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Order No</Form.Label>
                            <Form.Control type="text"   id="txtOrderNo" placeholder="" value={OrderNo} onChange={(e)=>setOrderNo(e.target.value)} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label><a onClick={(e) => setTMShow2(true)} href="#" >Stone Amt</a></Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled"  id="txtStoneAmt" placeholder="" value={StoneAmt} onChange={(e)=>setStoneAmt(e.target.value)} />
                          </div> 
                          

   </div>
	  </div>
</div>

</div>
</div>
                  
              </div>
             

              <Modal show={Tagshow2} onHide={TaghandleClose2} className=".modal-lg"  >
                  <Modal.Header closeButton>
                    <Form.Label>Tag Print</Form.Label>
                  </Modal.Header>  
                  <Modal.Body>
                <BarcodePage TagId={TagId} />
                </Modal.Body>
  
      <Modal.Footer>
    
       </Modal.Footer>


      </Modal>

			  	
				<Modal show={TMshow2} onHide={TMhandleClose2} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Label>Stone Details</Form.Label>
                  </Modal.Header>

                  <Modal.Body>
                    
                  <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-12'>  
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                        <div className='col-md-6'>
                            <Form.Label>Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtStProd.filter(function(option) {
                                             return option.value === StProdCode;
                                           })}
                                          options={dtStProd}
                                          id="txtStoneProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setStProdCode(e.value)
                                              getStsubProd()   
                                             }
                                             } >

                            </Select>


                          
                          </div>


                          <div className='col-md-6'>
                          <Form.Label>Sub Product</Form.Label>
                          <Select className="form-select-search" isSearchable={true} 
                                          value={dtStSubProd.filter(function(option) {
                                             return option.value === StSubCode;
                                           })}
                                          options={dtStSubProd}
                                          id="txtStoneSubProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setStSubCode(e.value)
                                             
                                             }
                                             }>
                            </Select>

                           
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtStonePcs" placeholder="" value={StonePcs} onChange={(e)=>{
                              setStonePcs(e.target.value)
                              StoneCalc()
                            }
                          } />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Weight</Form.Label>
                            <Form.Control type="text"  id="txtStoneWt" placeholder="" value={StoneWt} onChange={(e)=>{
                              setStoneWt(e.target.value)
                              StoneCalc()
                             }} />
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Rate</Form.Label>
                            <Form.Control type="text"  id="txtStoneRate" placeholder="" value={StoneRate} onChange={(e)=>{
                              setStoneRate(e.target.value)
                              StoneCalc()
                          } }/>
                          </div>

                          <div className='col-md-2'>
                            <Form.Label>Amount</Form.Label>
                            <Form.Control type="text"  id="txtStoneAmount" placeholder="" Readonly="Readonly" value={StoneAmount} onChange={(e)=>setStoneAmount(e.target.value)} />
                          </div>
  
                          <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={stgridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={StClear}>Cancel</Button>
                       </div>
</div></div></div></div></div></div></div>
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Edit</th>
             <th>Product</th>
             <th>Sub Product</th>   
             <th>Pcs</th>              
             <th>Weight</th>              
             <th>Rate</th>              
             <th>Amount</th>              
          
           </tr>
         </thead>
         <tbody>
         {DtStDetTable.map((item) => (
           <tr>
             <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>StgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>
            <td>{item.StProdName}</td>
             <td>{item.StSubProdName}</td>
             <td>{item.StPcs}</td>
             <td>{item.StWt}</td>
             <td>{item.StRate}</td>
             <td>{item.StAmount}</td>
            


           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>

           <Modal.Footer>
           <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={(e) => 
                      {setTMShow2(false)
                        StAmountCalc()
                        }}>OK</Button>
			                 </div>
                  </Modal.Footer>


                 </Modal>
				
	
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Search' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Issue No</th>
             <th>Prod Name</th>
             <th>Item Name</th>   
             <th>GRN No</th>              
             <th>Pcs</th>              
             <th>Weight</th>              
             
           </tr>
         </thead>
         <tbody>
         {dtGrnDetails.map((item) => (
           <tr>
            
   <td>  
    
     <Form.Check className="me-2">
                               
                               <Form.Check.Input type="radio" name="g1" onChange={(e) => setCheck(item.IssueNo,item.GrnNo)} checked={item.checked} className="lstItems" id={item.IssueNo} />
                               
                               <Form.Check.Label>{item.IssueNo}</Form.Check.Label>
                             </Form.Check>
                             </td>
         
             
             <td>{item.ProdName}</td>
             <td>{item.ItemName}</td>
             <td>{item.GrnNo}</td>
             <td>{item.BalPcs}</td>
             <td>{item.BalWt.toFixed(2)}</td>
            


           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' onClick={(e) => TagPrint()}>
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
